import * as o from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/CornersIn.es.js";
const r = o.forwardRef((e, n) => /* @__PURE__ */ o.createElement(s, { ref: n, ...e, weights: t }));
r.displayName = "CornersInIcon";
const c = r;
export {
  c as CornersIn,
  r as CornersInIcon
};
